module.exports = __webpack_public_path__ + "static/media/wcc.25ebd2a6.jpg";